var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAppPromotionIcon = function SvgAppPromotionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AppPromotionIcon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5589"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1245",
    d: "M0 0h30v30H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5588",
    transform: "translate(-3657 11194)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1256",
    width: 21,
    height: 25,
    rx: 2,
    transform: "translate(3664 -11191)",
    fill: "url(#AppPromotionIcon_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3810",
    d: "M3674.5-11185.408a6.908 6.908 0 106.908 6.908 6.908 6.908 0 00-6.908-6.908zm0 12.435a5.527 5.527 0 115.527-5.527 5.527 5.527 0 01-5.527 5.527zm.345-8.981h-2.072a.691.691 0 00-.691.691v5.527a.691.691 0 101.382 0v-1.382h1.382a.691.691 0 01.691.691v.691a.691.691 0 101.382 0v-.691a2.072 2.072 0 00-.54-1.381 2.072 2.072 0 00.539-1.382v-.691a2.072 2.072 0 00-2.072-2.073zm.691 2.763a.691.691 0 01-.691.691h-1.381v-2.072h1.382a.691.691 0 01.691.691z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1206",
    transform: "translate(3660 -11191)",
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 1.5
  }))))));
};
export default SvgAppPromotionIcon;